import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="lg:max-w-sm">
            <Link to="/" className="font-heading text-xl text-foreground-900">
              SuperbuySpread
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              An independent educational resource dedicated to helping users understand and use spreadsheet-based shopping management systems. Not affiliated with Superbuy official services.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-8 sm:gap-16">
            <div>
              <h4 className="font-heading text-sm text-foreground-900 mb-3">Quick Links</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Home</Link>
                <Link to="/superbuy-spreadsheet-complete-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Complete Guide</Link>
                <Link to="/superbuy-spreadsheet-templates" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Free Templates</Link>
                <Link to="/superbuy-spreadsheet-tutorial" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Beginner Tutorial</Link>
                <Link to="/superbuy-spreadsheet-safety" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Safety Guide</Link>
                <Link to="/superbuy-spreadsheet-comparison" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Comparison</Link>
              </div>
            </div>
            <div>
              <h4 className="font-heading text-sm text-foreground-900 mb-3">Categories</h4>
              <div className="grid grid-cols-2 gap-x-6 gap-y-2">
                {categories.slice(0, 8).map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="font-heading text-sm text-foreground-900 mb-3">More Categories</h4>
              <div className="grid grid-cols-1 gap-y-2">
                {categories.slice(8).map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} SuperbuySpread. All rights reserved. Independent educational resource.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-1.5 text-xs text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            Visit Main Store
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}